// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wiq8","left":"styles_left__PMmvn"};